var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58824 1.08824H2.41176C1.63207 1.08824 1 1.72031 1 2.50001C1 3.2797 1.63207 3.91177 2.41176 3.91177H7.58824C8.36793 3.91177 9 3.2797 9 2.50001C9 1.72031 8.36793 1.08824 7.58824 1.08824Z",
    stroke: "#5DA3E9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94118 2.50001C1.94118 2.2401 2.15187 2.02942 2.41176 2.02942H5.47059V2.97059H2.41176C2.15187 2.97059 1.94118 2.75991 1.94118 2.50001Z",
    stroke: "#5DA3E9",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41176 2.02942H7.58824C7.84814 2.02942 8.05882 2.2401 8.05882 2.50001C8.05882 2.75991 7.84814 2.97059 7.58824 2.97059H6.41176V2.02942Z",
    stroke: "#5DA3E9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentChannel);
export default __webpack_public_path__ + "static/media/Current_Channel.8c914412581ae909a0879fc6c3e5236b.svg";
export { ForwardRef as ReactComponent };